import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { store } from 'state/store';
import DetailsSection from './ScheduleCalendar/EventModal/DetailsSection/DetailsSection';
import { Typography } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import FacilitatorsSection from './ScheduleCalendar/EventModal/FacilitatorsSection/FacilitatorsSection';

export const DetailsSectionRenderer = ({
  existingEventData,
  projectsData,
  fmEventDescription,
  setEventTitle,
  setEventDescription,
  setProjectIds,
  setEventType,
  onUpdateEventField,
  initialProjects,
  detailsContainer,
}: {
  existingEventData: any;
  projectsData: any;
  fmEventDescription?: boolean;
  setEventTitle: (value: string) => void;
  setEventDescription: (value: string) => void;
  setProjectIds: (value: string[]) => void;
  setEventType: (value: string) => void;
  onUpdateEventField: (value: string, name: string | string[]) => void;
  initialProjects: string[];
  detailsContainer: HTMLElement;
}) => {
  return ReactDOM.render(
    <Provider store={store}>
      <DetailsSection
        existingEventData={existingEventData}
        projects={projectsData}
        changeEventData={(value, name) => {
          switch (name) {
            case 'eventTitle':
              setEventTitle(value);
              onUpdateEventField('subject', value);
              break;
            case 'description':
              setEventDescription(value);
              onUpdateEventField('description', value);
              break;
            case 'projectIds':
              setProjectIds(value);
              onUpdateEventField('projectIds', value);
              break;
            case 'learningEventTypeId':
              setEventType(value);
              onUpdateEventField('learningEventType', value);
              break;
            default:
              break;
          }
        }}
        projectIds={initialProjects}
        fmEventDescription={fmEventDescription}
      />
    </Provider>,
    detailsContainer
  );
};

export const FacilitatorsSectionRenderer = ({
  initialFacilitators,
  facilitatorsContainer,
  setSelectedFacilitatorsIds,
  onUpdateEventField,
}: {
  initialFacilitators: any;
  facilitatorsContainer: HTMLElement;
  setSelectedFacilitatorsIds: (value: string[]) => void;
  onUpdateEventField: (value: string, name: string | string[]) => void;
}) => {
  return ReactDOM.render(
    <Provider store={store}>
      <Typography variant='body2' className='mt-4 mb-4'>
        {intl.get('SCHEDULE.EVENTS.FACILITATORS_SECTION.TITLE')}
      </Typography>
      <FacilitatorsSection
        existingFacilitators={initialFacilitators}
        updateFacilitatorsIds={(selectedIds) => {
          setSelectedFacilitatorsIds(selectedIds);
          onUpdateEventField('facilitatorIds', selectedIds.sort());
        }}
      />
    </Provider>,
    facilitatorsContainer
  );
};

const Commons = { DetailsSectionRenderer, FacilitatorsSectionRenderer };

export default Commons;
